<template>
	<div
		class="fallback"
		:class="{ border: border, 'transparent-background': transparentBackground }"
		aria-label="Container for warnings, errors etc."
	>
		<font-awesome-icon
			v-if="icon"
			class="icon"
			:icon="[`${iconStyle}`, `${icon}`]"
		/>
		<div v-if="message" aria-label="warning or error message" class="message">
			{{ message }}
		</div>
		<slot class="slot" />
	</div>
</template>

<script>
export default {
	name: 'FallBack',
	props: {
		icon: String,
		iconStyle: String,
		message: String,
		border: {
			type: Boolean,
			default: true,
		},
		transparentBackground: Boolean,
	},
};
</script>

<style lang="scss" scoped>
.fallback {
	background: $white;
	border-radius: 6px;
	display: flex;
	flex-direction: column;
	width: 100%;
	height: 120px;
	text-align: center;
	justify-content: center;
	align-items: center;

	&.border {
		border: 1px solid $border-color-light;
	}

	&.transparent-background {
		background-color: transparent;
	}

	.icon {
		@include rem('font-size', 30px);
		color: $brand-blue;
	}

	.message,
	.slot {
		@include rem('margin', 10px);
	}
}
</style>
